import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    IconType,
    PageFrame,
    ResultScreen,
} from '@alfa-retail-react/components';

import { useApplicationContext } from 'app/store/сontext/ApplicationContext';
import { useAnalytics } from 'app/analytics/useAnalytics';

import './ResultPage.less';

interface ResultPageState {
    actionButtonTitle?: string;
    contentMessages?: string[];
    disableAnalytics?: boolean;
}

const TITLE = 'Заявка отправлена';
const DEFAULT_RESULT_MESSAGES = [
    'Решение придёт по СМС на номер телефона, указанный в заявке.',
    'Если мы одобрим заявку, вы получите кредит автоматически. Он появится в приложении INSNC в личном кабинете, в разделе Мои продукты.',
];
export const BUTTON_TITLE = 'Подробнее об INSNC';

/**
 * Страница успешного результата оформления заявки.
 */
export const ResultPage = () => {
    const landingUrl = (window as any).env.REFERER_URL;
    const applicationContext = useApplicationContext();
    const location = useLocation();
    const state = location.state as ResultPageState;
    const {
        actionButtonTitle = BUTTON_TITLE,
        contentMessages = DEFAULT_RESULT_MESSAGES,
        disableAnalytics = false,
    } = state || {};
    const analytics = useAnalytics(applicationContext.productCode, 'SuccessPage', false);

    useEffect(() => {
        if (!disableAnalytics) {
            analytics.pageDisplayed();
        }
    }, []);

    function handleResultAction() {
        window.location.href = landingUrl;
    }

    return (
        <PageFrame
            rightAddonLogo={applicationContext.additionalLogo}
            className="resultPage"
            displayFooter
        >
            <ResultScreen>
                <ResultScreen.Icon iconType={IconType.SUCCESS} />
                <ResultScreen.Header title={TITLE} />
                <ResultScreen.ContentBar messages={contentMessages} />
                <ResultScreen.ActionBar
                    actionButtons={[
                        {
                            children: actionButtonTitle,
                            view: 'accent',
                            onClick: handleResultAction,
                        },
                    ]}
                />
            </ResultScreen>
        </PageFrame>
    );
};
